FamilycardsImageLibrary.controller('editUserFormController', [ '$scope', function( $scope ) {

	$scope.editUserForm = [];

	$scope.setCheckboxTrueValue = function($field) {
		$scope.editUserForm[$field] = true;
	}

	$scope.setSelectValue = function($field, $value) {
		$scope.editUserForm[$field] = $value;
	}

	$scope.formatDate = function() {
		$scope.editUserForm.subscription_end_date_input = $scope.editUserForm.subscription_end_date.format('YYYY-MM-DD');
	}

	$scope.setDatepickerDate = function( $date ) {
		if( $date ) {
			$scope.editUserForm.subscription_end_date = moment($date);
			$scope.editUserForm.subscription_end_date_input = $scope.editUserForm.subscription_end_date.format('YYYY-MM-DD');
		} else {
			$scope.editUserForm.subscription_end_date = moment();
			$scope.editUserForm.subscription_end_date_input = '';
		}
		
		
	}


}]);